import api from "../api/auth";

const NewsRoomGetPostsService = async () => {
    try {
        const response = await api.get('/send_allnews');
        return response.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
};

export default NewsRoomGetPostsService